import { render, staticRenderFns } from "./SeriesList.vue?vue&type=template&id=4e7f36f1&scoped=true&"
import script from "./SeriesList.vue?vue&type=script&lang=js&"
export * from "./SeriesList.vue?vue&type=script&lang=js&"
import style0 from "./SeriesList.vue?vue&type=style&index=0&id=4e7f36f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7f36f1",
  null
  
)

export default component.exports